module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"emailAddress":"Email Address","length":"Must be less than 255 characters","invalid":"Invalid email"},"es":{"emailAddress":"Dirección de correo electrónico","length":"Debe tener menos de 255 caracteres","invalid":"Email inválido"},"sw":{"emailAddress":"Barua Pepe","length":"Lazima iwe chini ya herufi 255","invalid":"Barua pepe si sahihi"}}')
  delete Component.options._Ctor
}
